import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	useUpdateResolvedAutoReplyMutation,
	UpdateResolvedAutoReplyInput,
} from './__generated__/useUpdateResolvedAutoReplyMutation.graphql';

const mutation = graphql`
	mutation useUpdateResolvedAutoReplyMutation($input: UpdateResolvedAutoReplyInput!) {
		updateResolvedAutoReply(input: $input) {
			clientMutationId
			autoReply {
				resolvedEnabled
				resolvedFromName
				resolvedFromEmail
				resolvedBodyHtml
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateResolvedAutoReplyInput,
	onCompleted?: (r: useUpdateResolvedAutoReplyMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useUpdateResolvedAutoReplyMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useUpdateResolvedAutoReplyMutation'};
